import React from "react";
import Highcharts from "highcharts";
import HighchartsReact from "highcharts-react-official";
import "../GroupBarChart/GroupBarChart.css";
import { BiBorderRadius } from "react-icons/bi";

const GroupBarChart = () => {
  const options = {
    chart: {
      type: "column",
      height: 310,
    },
    xAxis: {
      categories: ["Comp A", "Comp B", "Comp C", "Comp D"],
      title: {
        text: "Companies",
        align: "low",
        x: 0,
        y: 5,
        style: {
          color: "#999",
          fontSize: "14px",
        },
      },
      labels: {
        style: {
          color: "#999",
          fontSize: "14px",
        },
      },
      lineWidth: 1.7,
      lineColor: "rgb(167, 167, 167)",
    },
    yAxis: {
      min: 10,
      max: 100,
      title: {
        text: "Performance Metrics",
        align: "high",
        rotation: 90,
        x: -10,
        y: 230,
        style: {
          color: "#999",
          fontSize: "14px",
        },
      },
      labels: {
        style: {
          color: "#999",
          fontSize: "14px",
        },
      },
      lineWidth: 1.7,
      lineColor: "rgb(167, 167, 167)",
    },
    series: [
      {
        name: "Compliance",
        data: [55, 85, 92, 70],
        color: "#5662be",
      },
      {
        name: "Quality",
        data: [81, 35, 89, 91],
        color: "#7a86df",
      },
      {
        name: "Delivery",
        data: [75, 60, 40, 50],
        color: "#efc58a",
      },
    ],
    plotOptions: {
      column: {
        grouping: true,
        borderWidth: 0,
      },
    },
    legend: {
      enabled: false,
    },
    tooltip: {
      style: {
        color: "#999",
        fontSize: "14px",
      },
      backgroundColor: "white",
      borderColor: "#999",
      borderWidth: 1,
      borderRadius: 0,
      padding: 10,
      shadow: false,
    },
  };

  return (
    <section className="section">
      <div className="groupbar-container">
        <div className="groupbar-header">
          <h1>Company Perf: Compliance, Quality, Delivery <sub style={{color: "blue"}}>(Group bar chart)</sub></h1>
        </div>

        <div className="groupbar-parent">
          <div className="group-count-wrapper">
            <div>
              <i className="fa-solid fa-circle" style={{ color: "#5662be" }}></i>{" "}
              Compliance
            </div>
            <div>
              <i className="fa-solid fa-circle" style={{ color: "#7a86df" }}></i>{" "}
              Quality
            </div>
            <div>
              <i className="fa-solid fa-circle" style={{ color: "#efc58a" }}></i>{" "}
              Delivery
            </div>
          </div>
            <HighchartsReact highcharts={Highcharts} options={options} />
        </div>
      </div>
    </section>
  );
};

export default GroupBarChart;
